import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorsMessagesComponent } from './errors-messages/errors-messages.component';
import { ErrorsMessagesInlineComponent } from './errors-messages-inline/errors-messages-inline.component';

@NgModule({
  declarations: [ErrorsMessagesComponent, ErrorsMessagesInlineComponent],
  exports: [ErrorsMessagesComponent, ErrorsMessagesInlineComponent],
  imports: [CommonModule],
})
export class FormErrorsModule {}
